export default "__VITE_ASSET__CZujVqbh__"